<!-- MasonryLayout.vue -->
<template>
  <div class="masonry-layout">
    <div class="grid-item" v-for="(item, index) in images" :key="index">
      <img class="responsive-image" :src="item.image" alt="slide image" @click="showPreview(item.image)" />
    </div>
    <slot></slot>
    <div v-if="showPreviewModal" class="preview-modal" @click.self="closePreview">
      <img :src="previewImage"  @click.self="closePreview" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MasonryLayout',
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    cols: {
      type: Object,
      default: () => ({ default: 4, 768: 3, 576: 2 }),
    },
    gutter: {
      type: Number,
      default: 10,
    },
  },
  data () {
    return {
      showPreviewModal: false,
      previewImage: null,
    }
  },
  methods: {
    showPreview(image) {
      this.showPreviewModal = true;
      this.previewImage = image.replace('mosaic', 'compact');
    },
    closePreview() {
      this.showPreviewModal = false;
    },
  },
};
</script>

<style scoped>
.masonry-layout {
  column-count: 2;
  column-gap: 1px;
}

@media (max-width: 767px) {
  .masonry-layout {
    column-count: 2;
  }
}

@media (max-width: 575px) {
  .masonry-layout {
    column-count: 2;
  }
}

.grid-item {
  break-inside: avoid;
  padding: 5px;
  box-sizing: border-box;
}

.grid-item img {
  width: 100%;
  height: auto;
  display: block;
}
.preview-modal {
  position: fixed;
  top: 45px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-modal img {
  max-width: 97%;
  max-height: 97%;
  object-fit: contain;
}

</style>
